import React from "react";

export type EnhancedEventDetectionContextType = {
  inLongPress: boolean;
  active: boolean;
};

export const EnhancedEventDetectionContext = React.createContext<
  EnhancedEventDetectionContextType | undefined
>(undefined);
